module.exports = __webpack_public_path__ + "img/Wache.962cf382.svg";